import React, { useState } from "react";
import { Box, Button, InputAdornment, TextField, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CustomButton from "components/CustomButton";
import GoalForm from "components/GoalSetting/GoalForm";
import GoalsTabComponent from "components/GoalSetting/GoalsTab";

const Goals = () => {
  const [goalFormOpen, setGoalFormOpen] = useState<boolean>(false);

  const handleGoalFormOpen = () => {
    setGoalFormOpen(true);
  };

  const handleGoalFormClose = () => {
    setGoalFormOpen(false);
  };

  return (
    <Box display="flex" flexDirection="column">
      {/* Search Bar */}
      <Typography variant="h6" sx={{ fontSize: "12px", fontWeight: 800 }}>
        SEARCH GOAL NAME
      </Typography>
      <Box display="flex" alignItems="center" mb={1}>
        <TextField
          type="search"
          id="search"
          label="Search"
          sx={{ width: 500 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Button variant="contained" color="primary">
                  Search
                </Button>
              </InputAdornment>
            ),
          }}
        />
        <CustomButton
          startIcon={<AddIcon />}
          title="Create Goal"
          sx={{ ml: 3 }}
          onClick={handleGoalFormOpen}
        />
        <GoalForm goalFormOpen={goalFormOpen} handleGoalFormClose={handleGoalFormClose} />
      </Box>
      {/* Goals Tab Component */}
      <GoalsTabComponent />
    </Box>
  );
};

export default Goals;
